import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_kre9mxccqw: FaireCollectionEntity = {
  token: "pbc_kre9mxccqw",
  type: "collection",
  name: "Christmas",
  heroImageUrl:
    "https://cdn.faire.com/fastly/737a3e6a6c4207331d3edfccd953677b1b0c77596e3798f5eb6839f009a98e6b.jpeg",
  itemCount: 61,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.606Z",
    importedBy: "entity-db-import-collections",
  },
};
